<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>已删除客户</el-breadcrumb-item>
    </el-breadcrumb>
    <customer-list :deleted="true"></customer-list>
  </div>
</template>

<script>
import CustomerList from './list'
export default {
  props: {
    dealerID: {
      type: Number,
      default: 0,
    },
  },
  components: { CustomerList },
}
</script>